import ThemeLoader, { themeContext } from './ThemeLoader';
import { hex, darken, getContrastColor, mixColors } from '../../../Utils/color';

export default ThemeLoader;
export { themeContext };

export const setPrimaryColor = (color?: hex): void => {
  if (!color) {
    document.documentElement.style.removeProperty('--color-primary');
    document.documentElement.style.removeProperty('--color-primary-dark');
    document.documentElement.style.removeProperty('--color-primary-darkest');
    return;
  }

  document.documentElement.style.setProperty('--color-primary', color);
  document.documentElement.style.setProperty('--color-primary-dark', darken(color));
  document.documentElement.style.setProperty('--color-primary-darkest', darken(color, 0.4));
};

export const setSecondaryColor = (color?: hex): void => {
  if (!color) {
    document.documentElement.style.removeProperty('--color-secondary');
    return;
  }

  document.documentElement.style.setProperty('--color-secondary', color);
};

export const setMenuColor = (color?: hex): void => {
  if (!color) {
    document.documentElement.style.removeProperty('--color-menu-dark');
    document.documentElement.style.removeProperty('--color-menu-darkest');
    document.documentElement.style.removeProperty('--color-menu-highlighted');
    document.documentElement.style.removeProperty('--color-menu-text');
    document.documentElement.style.removeProperty('--color-menu-alt-text');
    return;
  }

  document.documentElement.style.setProperty('--color-menu-dark', color);
  document.documentElement.style.setProperty('--color-menu-darkest', darken(color));

  const contrastColor = getContrastColor(color);
  document.documentElement.style.setProperty('--color-menu-highlighted', mixColors(contrastColor, color, 0.05));
  document.documentElement.style.setProperty('--color-menu-text', contrastColor);
  document.documentElement.style.setProperty('--color-menu-alt-text', mixColors(contrastColor, color, 0.7));
};
